<template>
  <div class="status-container">
    <h1 :style="{ color: statusColor }">{{ title }}</h1>
    <p>{{ message }}</p>
    <p class="back-link cursor-pointer" @click="goBack">Voltar para a página inicial</p>
  </div>
</template>

<script>
export default {
  name: "DespedidaStatus",
  props: {
    status: {
      type: String,
      required: true,
      validator: value => ['not-found', 'private', 'inactive'].includes(value)
    }
  },
  methods: {
    goBack() {
      // Verifica se há pelo menos duas páginas no histórico
      if (window.history.length > 2) {
        // Volta duas páginas atrás
        window.history.go(-2);
      } else if (window.history.length > 1) {
        // Se não houver duas páginas, volta apenas uma
        window.history.back();
      } else {
        // Se não houver histórico, vai para a página inicial
        this.$router.push('/');
      }
    }
  },
  computed: {
    title() {
      const titles = {
        'not-found': 'Despedida não localizada',
        'private': 'Despedida Privada',
        'inactive': 'Despedida Inativa'
      };
      return titles[this.status];
    },
    message() {
      const messages = {
        'not-found': 'A despedida que você está tentando acessar não foi encontrada ou não existe.',
        'private': 'Esta despedida é privada. Você precisa de um código de acesso para visualizá-la.',
        'inactive': 'Esta despedida não está mais disponível para visualização.'
      };
      return messages[this.status];
    },
    statusColor() {
      const colors = {
        'not-found': '#e74c3c',
        'private': '#3498db',
        'inactive': '#95a5a6'
      };
      return colors[this.status];
    }
  }
};
</script>

<style scoped>
.status-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
  padding: 0 20px;
}

h1 {
  margin-bottom: 16px;
  font-size: 2rem;
}

p {
  margin-bottom: 24px;
  color: #2c3e50;
  max-width: 600px;
  line-height: 1.5;
}

.back-link {
  color: #2c3e50;
  text-decoration: none;
  padding: 10px 20px;
  border: 2px solid currentColor;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.back-link:hover {
  background-color: #2c3e50;
  color: white;
  text-decoration: none;
}
</style>
